import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 60 60\" id=\"icon-download\">\r\n  <path d=\"M18 43V41h24v2z\" />\r\n  <path d=\"M28.86 17v17.35l-7.19-7.18-1.67 1.67 9.21 9.21.84.84 10.04-10.05-1.67-1.67-7.19 7.18V17z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol